export const DEFAULT_COMBO_RESET_MS = 1500;

export function parseComboResetMs(themeData) {
  const raw =
    themeData?.combo_reset_ms ??
    themeData?.comboResetMs ??
    themeData?.combo_timeout_ms ??
    themeData?.comboTimeoutMs;
  const n = Number(raw);
  if (Number.isFinite(n) && n > 0) return Math.floor(n);
  return DEFAULT_COMBO_RESET_MS;
}

/** Combo includes the hit that just landed (1-based streak length after increment). */
export function comboMultiplierForStreak(comboAfterHit) {
  const c = Math.max(0, Math.floor(comboAfterHit));
  if (c >= 25) return 2.5;
  if (c >= 15) return 2.0;
  if (c >= 10) return 1.5;
  if (c >= 5) return 1.2;
  return 1.0;
}
